import { getMediaImageUrl } from '../../../utils/img';

export const findVariation = (product, vantionKey) => {
  const variations = product.variations || [];
  return variations.find((variation) => variation.key === vantionKey);
};

export const getProductImageUrl = (
  product,
  vantionKey,
  options = { size: '160x' },
) => {
  const { media } = product;
  const targetVariation = findVariation(product, vantionKey);

  if (targetVariation?.media) {
    return (
      getMediaImageUrl(targetVariation.media, options) ||
      getMediaImageUrl(media[0], options)
    );
  }

  return getMediaImageUrl(media[0]);
};
